import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import PhoneInput, {
  isValidPhoneNumber,
} from 'react-phone-number-input';

const FormikPhoneField = ({
  formik: { errors, handleBlur, handleChange, touched, values },
  name,
  placeholder,
  showError = true,
  validation = {},
  onChange,
  ...props
}) => {

  return (
    <PhoneInput
      countryCallingCodeEditable={false}
      defaultCountry="FR"
      international
      limitMaxLength
      name={name}
      placeholder={placeholder}
      value={values[name] || ''}
      onChange={(value) => {
        const phoneValue = value || '';
        if (onChange) {
          onChange({ target: { name, value: phoneValue } });
        } else {
          handleChange({ target: { name, value: phoneValue } });
        }
      }}
      onBlur={(e) => {
        handleBlur(e);
      }}
      error={showError && touched[name] && !!errors[name]}
      {...props}
    />
  );
};

const styles = () => ({});

FormikPhoneField.propTypes = {
  formik: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  showError: PropTypes.bool,
  validation: PropTypes.object,
  onChange: PropTypes.func,
};

export default FormikPhoneField;